import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { lighten } from '@mui/material/styles';
import JwtLoginTab from '../tabs/sign-in/JwtSignInTab';
import SignInPageTitle from '../ui/SignInPageTitle';

/**
 * The sign in page - JWT only for Dorat (ClassicSignInPageView styling)
 */
function SignInPageView() {
	return (
		<div className="flex min-w-0 flex-auto flex-col items-center sm:justify-center">
			<Paper className="min-h-full w-full rounded-none px-4 py-8 sm:min-h-auto sm:w-auto sm:rounded-xl sm:p-12 sm:shadow-sm">
				<div className="mx-auto flex w-full max-w-80 flex-col gap-8 sm:mx-0 sm:w-80">
					<SignInPageTitle />
					<div>
						<JwtLoginTab />
					</div>

					<Box
						className="text-md rounded-lg px-4 py-2 leading-[1.625]"
						sx={{
							backgroundColor: (theme) => lighten(theme.palette.primary.main, 0.8),
							color: 'primary.dark'
						}}
					>
						Welcome to <b>Dorat</b>. Please sign in to access your dashboard.
					</Box>
				</div>
			</Paper>
		</div>
	);
}

export default SignInPageView;
